import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';
import { TokenService } from '../_services/token-service.service';
import { LoggerService } from '../_services/logger.service';
import { LoadingService } from '../_services/loading.service';
import { IndexedDbService } from '../_services/indexed-db.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
    private tokenService: TokenService,
    private router: Router,
    private loadingService: LoadingService,
    private logger: LoggerService,
    private db: IndexedDbService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // pega o token do IndexedDB e transforma em Observable
    return from(this.db.getData('id_token')).pipe(
      switchMap(idToken => {
        let authReq = req;
        if (idToken) {
          authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${idToken}` }
          });
        }

        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            this.logger.log('Interceptor pegou erro:', error.status);

            if (error.status === 401) {
              // tenta refresh token usando Observable
              this.logger.log('Token expired, trying to refresh');
              return this.tokenService.refreshToken().pipe(
                switchMap(newToken => {
                  const retryReq = req.clone({
                    setHeaders: { Authorization: `Bearer ${newToken}` }
                  });
                  return next.handle(retryReq);
                }),
                catchError(refreshError => {
                  this.logger.error('Token refresh failed', refreshError);
                  this.authenticationService.logout();
                  this.router.navigate(['/login']);
                  return throwError(() => refreshError);
                })
              );
            }

            return throwError(() => error);
          })
        );
      })
    );
  }
}
